import { render, staticRenderFns } from "./LimitedTimeVip.vue?vue&type=template&id=29438c64"
import script from "./LimitedTimeVip.vue?vue&type=script&lang=js"
export * from "./LimitedTimeVip.vue?vue&type=script&lang=js"
import style0 from "./LimitedTimeVip.vue?vue&type=style&index=0&id=29438c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports